import request from 'config/axios'

const configs = {
  responseType: 'arraybuffer'
}

const getSummaryURL = ({ accountType, startDate, endDate }) =>
  `gringott/tradingSummary/${accountType}?startDate=${startDate}&endDate=${endDate}`

const getReportURL = ({ accountType, startDate, endDate, format }) =>
  `gringott/tradingReport/${accountType}?startDate=${startDate}&endDate=${endDate}&format=${format}`

export const getTransactionHistorySummary = ({ payload }) => request.get(getSummaryURL(payload))

export const getTransactionHistoryReport = ({ payload }) => request.get(
  getReportURL(payload),
  configs
)
